<template>
  <div>
    <main-layout>
      <div class="content-wrap ledger-order" v-loading="loading">
        <el-form
          :inline="true"
          size="small"
          label-width="100px"
          label-position="right"
          ref="ledgerOrderSearchForm"
          :model="form"
        >
          <el-form-item label="创建分账日期" prop="date">
            <DatePicker
              class="w224"
              v-model="date"
              :reset="resetDate"
              type="daterange"
              format="yyyy-MM-dd"
              :defaultValue="createDateDefaultValue"
            />
          </el-form-item>
          <el-form-item label="分账订单号" prop="orderNo">
            <el-input class="w224" v-model="form.orderNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="分账状态" prop="status">
            <el-select v-model="form.status" class="w224">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门/门店" prop="departmentId">
            <treeselect
              class="tree-select form-select"
              :default-expand-level="1"
              noOptionsText="暂无选项"
              noResultsText="暂无选项"
              v-model="form.departmentId"
              placeholder="请输入"
              :normalizer="normalizer"
              :options="departList"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search">
              搜索
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="ledger-order-content">
          <el-button
            type="primary"
            size="small"
            @click="exportData"
            class="show-export-ledger-button"
            >批量导出</el-button
          >
          <el-table :data="tableData">
            <el-table-column label="创建分账时间">
              <template slot-scope="scope">
                <p>
                  {{ scope.row.createTime && String(scope.row.createTime).substring(0, 10) }}
                </p>
                <p>
                  {{ scope.row.createTime && String(scope.row.createTime).substring(11, 19) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="分账订单号" prop="orderNo"> </el-table-column>
            <el-table-column label="所属部门/门店" prop="departmentName"> </el-table-column>
            <el-table-column label="订单总额/日期">
              <template slot-scope="scope">
                <p class="column-order-total-text">
                  {{ scope.row.orderAmount | numberFormat }}
                </p>
                <p class="column-order-date-text">
                  {{ scope.row.payTime && String(scope.row.payTime).substring(0, 10) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="手续费">
              <template slot-scope="scope">
                <p class="column-order-premium-text">
                  {{ scope.row.fee | numberFormat }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="分账状态">
              <template slot-scope="scope">
                <p>
                  <i
                    class="iconfont icon-yuandian subaccount-status"
                    :style="{ color: renderLedgerColor(scope.row.status) }"
                  ></i>
                  {{ scope.row.statusName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="ledgerDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <Paging
            layout="prev, pager, next, total, sizes, jumper"
            v-if="total > 3"
            :currentPage="pageObj"
            :total="total"
            :handleCurrentChange="handleCurrentChange"
            :handleSizeChange="handleSizeChange"
            :pageSizes="[10, 50, 100]"
          ></Paging>
        </div>
        <OrderDetailModal
          :detailVisible="detailVisible"
          @handleClose="handleClose"
          :formData="detailForm"
        />
      </div>
    </main-layout>
  </div>
</template>
<script>
import MainLayout from '@/views/layout/mainlayout';
import DatePicker from '@components/public/datePicker';
import Treeselect from '@riophae/vue-treeselect';
import Paging from '../../components/public/paging';
import OrderDetailModal from './orderDetailModal';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { getInTheLatestWeek } from '@utils/times';

export default {
  name: 'LedgerOrders',
  components: {
    MainLayout,
    Treeselect,
    Paging,
    OrderDetailModal,
    DatePicker,
  },
  data() {
    return {
      exportAuth: true, // 导出权限
      detailVisible: false,
      detailForm: {},
      loading: false,
      total: 12,
      pageObj: {
        pageSize: 10,
        currentPage: 1,
      },
      tableData: [],
      aCount: 0,
      pCount: 20,
      departList: [], // 部门list
      treeData: '',
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        };
      },
      date: [],
      resetDate: false,
      createDateDefaultValue: getInTheLatestWeek(),
      form: {
        startDate: '',
        endDate: '',
        orderNo: '',
        status: '',
        departmentId: null,
      },
      statusList: [
        {
          label: '未分账',
          val: 1,
        },

        {
          label: '分账中',
          val: 2,
        },
        {
          label: '已分账',
          val: 3,
        },
        {
          label: '分账失败',
          val: 4,
        },
      ],
    };
  },
  watch: {
    date(newVal) {
      const [startDate, endDate] = newVal;
      this.form.startDate = startDate?.substring(0, 10);
      this.form.endDate = endDate?.substring(0, 10);
    },
  },
  created() {
    // 获取部门/门店信息
    this.api.post('load/getDeptTree.do', {}).then((res) => {
      if (res.code == '200') {
        this.treeData = res.data;
        this.departList = res.data;
      } else {
        this.$message.error(res.message);
      }
    });
    const [startDate, endDate] = getInTheLatestWeek();
    this.form.startDate = startDate.substring(0, 10);
    this.form.endDate = endDate.substring(0, 10);
    this.getTableData();
    // 导出权限判断
    const registerType = sessionStorage.getItem('registerType');
    if (registerType === '0') {
      const exportSubAccountOrderAuth = JSON.parse(sessionStorage.getItem('exportSubAccountOrder'));
      this.exportAuth = exportSubAccountOrderAuth;
    }
  },
  methods: {
    ledgerDetail(row) {
      this.detailVisible = true;
      this.api
        .post('/subaccount/order/querySubAccountOrder.do', {
          id: row.id,
          taxNo: row.taxNo,
        })
        .then(({ code, data, message }) => {
          if (code === 200) {
            this.detailForm = data;
          } else {
            this.$message.error(message);
          }
        });
    },
    search() {
      this.$refs.ledgerOrderSearchForm.validate((validate, obj) => {
        if (validate) {
          this.getTableData();
        }
      });
    },
    getTableData(pageData = { currentPage: 1, pageSize: 10 }) {
      this.loading = true;
      this.api
        .post('/subaccount/order/querySubAccountOrderPage.do', {
          ...pageData,
          ...this.form,
        })
        .then(({ code, data, message }) => {
          if (code === 200) {
            this.tableData = data.result || [];
            this.total = Number(data.aCount);
          } else {
            this.$message.error(message);
          }
          this.loading = false;
        });
    },
    resetSearchForm() {
      this.resetDate = !this.resetDate;
      this.$refs.ledgerOrderSearchForm.resetFields();
      const [startDate, endDate] = getInTheLatestWeek();
      this.form.startDate = startDate.substring(0, 10);
      this.form.endDate = endDate.substring(0, 10);
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageObj.currentPage = val;
      this.pageObj = { ...this.pageObj };
      this.getTableData(this.pageObj);
    },
    handleSizeChange(size) {
      this.pageObj = { pageSize: size, currentPage: 1 };
      this.getTableData(this.pageObj);
    },
    exportData() {
      if (this.exportAuth) {
        const downloadParams = { ...this.pageObj, ...this.form };
        const postParams = [];
        Object.keys(downloadParams).forEach((key) => {
          if (downloadParams[key]) {
            postParams.push(`${key}=${downloadParams[key]}`);
          }
        });
        location.href = `/juheCustomer/subaccount/order/exportSubAccountOrder.do?${postParams.join(
          '&',
        )}`;
      } else {
        this.$message.error('您无分账订单导出权限，请联系企业开通权限');
      }
    },
    handleClose() {
      this.detailVisible = false;
    },
    renderLedgerColor(val) {
      switch (val) {
        case '1':
          return '#CCCCCC';
        case '2':
          return '#1989FA';
        case '3':
          return '#5CD700';
        case '4':
          return '#FF003C';
        default:
          return '#CCCCCC';
      }
    },
  },
};
</script>
<style scoped lang="scss">
.ledger-order-content {
  min-height: 350px;
  .show-export-ledger-button {
    margin-top: 6px;
    margin-bottom: 32px;
    width: 82px;
  }
  .column-order-date-text,
  .column-order-total-text {
    text-align: right;
    width: 86px;
  }
  .column-order-premium-text {
    text-align: right;
    width: 40px;
  }
  .column-order-date-text {
    color: rgba(0, 0, 0, 0.25);
  }
  .subaccount-status {
    margin-left: -6px;
  }
}
.ledger-order {
  .form-select,
  .w224 {
    width: 224px;
  }
  .el-form-item:last-child {
    margin-left: 100px;
  }
}
</style>
